import { env } from "./config";

export const resolveMediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${env.MINIO_BASE_URL}${url}`;
};
